import React, { SVGProps } from "react";

export default function SupDepositOut(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.99979 3.99377L7.17175 6.82181L7.87886 7.52892L9.36806 6.03972V12.0873C8.53902 12.3314 7.93385 13.0981 7.93385 14.0061C7.93385 15.1107 8.82928 16.0061 9.93385 16.0061C11.0384 16.0061 11.9338 15.1107 11.9338 14.0061C11.9338 13.0507 11.2639 12.2517 10.3681 12.0534V5.77626L12.1211 7.52931L12.8282 6.8222L9.99979 3.99377Z"
        fill="currentColor"
      />
    </svg>
  );
}
